const pageBreakDefaultOptions = {}

export default pageBreakDefaultOptions
